/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  "use strict";

  function redirectMetaResultsRootUrl() {
    var params = new URLSearchParams(window.location.search);
    if (window.location.pathname === "/" && params.has("field") && params.has("value")) {
      window.location.replace("/pages/meta-results-live" + window.location.search);
    }
  }

  redirectMetaResultsRootUrl();

  var lockSensitiveSelectors = [
    "#mini-cart[aria-hidden='false']",
    "#mobile-menu[aria-hidden='false']",
    "#mobile-collection-filters[aria-hidden='false']",
    ".mobile-menu[aria-hidden='false']",
    ".search-bar[aria-hidden='false']",
    ".modal[aria-hidden='false']",
    ".drawer[aria-hidden='false']",
    ".popover[aria-hidden='false']",
    ".value-picker[aria-hidden='false']"
  ];

  var lockRecoveryTimer = null;
  var lockRecoveryDeadline = 0;

  function copyTextToClipboard(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      try {
        var helper = document.createElement("textarea");
        helper.value = value;
        helper.setAttribute("readonly", "");
        helper.style.position = "fixed";
        helper.style.top = "-9999px";
        helper.style.left = "-9999px";
        document.body.appendChild(helper);
        helper.select();
        helper.setSelectionRange(0, helper.value.length);

        var copied = document.execCommand("copy");
        document.body.removeChild(helper);
        copied ? resolve() : reject(new Error("Copy failed"));
      } catch (error) {
        reject(error);
      }
    });
  }

  function markCopied(trigger) {
    trigger.classList.add("is-copied");
    window.setTimeout(function () {
      trigger.classList.remove("is-copied");
    }, 1200);
  }

  function getMetaRowCollapsedHeight(metaRow) {
    var computedStyle = window.getComputedStyle(metaRow);
    var lineHeight = parseFloat(computedStyle.lineHeight);

    if (!Number.isFinite(lineHeight) || lineHeight <= 0) {
      var fontSize = parseFloat(computedStyle.fontSize);
      if (Number.isFinite(fontSize) && fontSize > 0) {
        lineHeight = fontSize * 1.2;
      }
    }

    if (!Number.isFinite(lineHeight) || lineHeight <= 0) {
      lineHeight = 24;
    }

    return Math.max(16, Math.floor(lineHeight));
  }

  function runMetaExpandContent() {
    var rows = document.querySelectorAll(".product-meta .meta_row_wrapper");
    if (!rows.length) {
      return;
    }

    rows.forEach(function (row) {
      var metaRow = row.querySelector(".meta_row");
      if (!metaRow) {
        return;
      }

      var collapsedHeight = getMetaRowCollapsedHeight(metaRow);
      row.style.setProperty("--bbb-meta-collapsed-height", collapsedHeight + "px");

      var isActiveRow = metaRow.classList.contains("active");
      if (isActiveRow) {
        row.classList.remove("hide_all_content");
        row.style.maxHeight = "100%";
        return;
      }

      row.style.maxHeight = collapsedHeight + "px";

      if (metaRow.scrollHeight > collapsedHeight + 1) {
        row.classList.add("hide_all_content");
      } else {
        row.classList.remove("hide_all_content");
      }
    });
  }

  function hasOpenLockingUI() {
    return lockSensitiveSelectors.some(function (selector) {
      return !!document.querySelector(selector);
    });
  }

  function releaseScrollLockIfSafe(force) {
    var body = document.body;
    var root = document.documentElement;

    if (!root || !body) {
      return;
    }

    if (!force && hasOpenLockingUI()) {
      return;
    }

    root.classList.remove("is-locked");
    body.classList.remove("is-locked");

    if (!hasOpenLockingUI()) {
      root.style.overflow = "";
      root.style.overflowY = "";
      body.style.overflow = "";
      body.style.overflowY = "";
    }
  }

  function startLockRecoveryWindow(durationMs) {
    if (
      !document.documentElement.classList.contains("is-locked") &&
      !document.body.classList.contains("is-locked") &&
      !hasOpenLockingUI()
    ) {
      return;
    }

    lockRecoveryDeadline = Date.now() + durationMs;

    if (lockRecoveryTimer) {
      return;
    }

    lockRecoveryTimer = window.setInterval(function () {
      releaseScrollLockIfSafe(false);

      if (
        !document.documentElement.classList.contains("is-locked") &&
        !document.body.classList.contains("is-locked") &&
        !hasOpenLockingUI()
      ) {
        window.clearInterval(lockRecoveryTimer);
        lockRecoveryTimer = null;
        return;
      }

      if (Date.now() >= lockRecoveryDeadline) {
        window.clearInterval(lockRecoveryTimer);
        lockRecoveryTimer = null;
      }
    }, 320);
  }

  function scheduleLockCleanup(force) {
    var shouldForce = !!force;

    window.requestAnimationFrame(function () {
      releaseScrollLockIfSafe(shouldForce);
    });

    window.setTimeout(function () {
      releaseScrollLockIfSafe(shouldForce);
    }, 120);

    startLockRecoveryWindow(1800);
  }

  function handleShowAllClick(trigger) {
    var parentRow = trigger.closest(".meta_row_wrapper");
    var rowBlock = trigger.closest(".meta_row");

    if (!parentRow || !rowBlock) {
      return;
    }

    rowBlock.classList.add("active");
    parentRow.classList.remove("hide_all_content");
    parentRow.style.maxHeight = "100%";
    trigger.style.display = "none";
  }

  function handleCopyLink(trigger) {
    var targetId = trigger.getAttribute("data-copy-url-target");
    var copyTarget = targetId ? document.getElementById(targetId) : document.getElementById("copyUrl");

    if (!copyTarget) {
      copyTarget = document.querySelector(".copy-url-field");
    }

    var value = copyTarget ? copyTarget.value : window.location.href;
    if (!value) {
      return;
    }

    copyTextToClipboard(value).then(function () {
      markCopied(trigger);
    }).catch(function () {
      window.prompt("Copy this link:", value);
    });
  }

  function getPrimeBadgeUrl(trigger) {
    if (!trigger) {
      return "";
    }

    var onClickAttr = trigger.getAttribute("onclick") || "";
    if (!onClickAttr) {
      return "";
    }

    var match = onClickAttr.match(/redirectLinkbadge\(\s*['"]([^'"]*)['"]/i);
    if (!match || !match[1]) {
      return "";
    }

    return String(match[1]).trim();
  }

  function getVariantMetaMap(container) {
    if (!container || !container.querySelector) {
      return null;
    }

    var script = container.querySelector("script[data-bbb-variant-meta]");
    if (!script) {
      return null;
    }

    if (script.__bbbVariantMetaMap) {
      return script.__bbbVariantMetaMap;
    }

    try {
      script.__bbbVariantMetaMap = JSON.parse(script.textContent || "{}");
    } catch (error) {
      script.__bbbVariantMetaMap = {};
    }

    return script.__bbbVariantMetaMap;
  }

  function normalizeFormatValues(rawValue) {
    if (Array.isArray(rawValue)) {
      return rawValue.map(function (item) {
        return String(item || "").trim();
      }).filter(Boolean);
    }

    if (rawValue == null) {
      return [];
    }

    var value = String(rawValue).trim();
    if (!value) {
      return [];
    }

    try {
      var parsedValue = JSON.parse(value);
      if (Array.isArray(parsedValue)) {
        return parsedValue.map(function (item) {
          return String(item || "").trim();
        }).filter(Boolean);
      }
    } catch (error) {}

    return value
      .replace(/^\[/, "")
      .replace(/\]$/, "")
      .split(",")
      .map(function (item) {
        return item.replace(/"/g, "").trim();
      })
      .filter(Boolean);
  }

  function setVisible(element, isVisible) {
    if (!element) {
      return;
    }

    element.style.display = isVisible ? "" : "none";
  }

  function buildMetaResultsLink(baseUrl, field, value) {
    var separator = baseUrl.indexOf("?") === -1 ? "?" : "&";
    return baseUrl + separator + "field=" + encodeURIComponent(field) + "&value=" + encodeURIComponent(value);
  }

  function updateVariantBookDetails(container, variant, variantMeta) {
    if (!container || !variantMeta) {
      return;
    }

    var barcodeEl = container.querySelector(".product-meta__barcode");
    var imprintValue = variantMeta.imprint ? String(variantMeta.imprint).trim() : "";
    var qrCodeSupportEl = container.querySelector(".qr_code_support");

    if (barcodeEl) {
      var barcode = (variant && variant.barcode) || variantMeta.barcode || "";
      setVisible(barcodeEl, barcode !== "");

      if (barcode !== "") {
        var barcodeValueEl = barcodeEl.querySelector(".product-meta__barcode-number");
        if (barcodeValueEl) {
          barcodeValueEl.textContent = barcode;
        }
      }

      var barcodeDividerEl = barcodeEl.querySelector(".product-meta__barcode-divider");
      if (barcodeDividerEl) {
        setVisible(barcodeDividerEl, imprintValue !== "" || !!qrCodeSupportEl);
      }
    }

    var imprintEl = container.querySelector("[data-bbb-imprint-link]") || container.querySelector(".product-meta__vendor");
    setVisible(imprintEl, imprintValue !== "");

    if (imprintEl && imprintValue !== "") {
      var metaResultsUrl = imprintEl.getAttribute("data-meta-results-url") || "/apps/meta-results-share?preview_v=202607181036";
      imprintEl.textContent = imprintValue;
      imprintEl.setAttribute("href", buildMetaResultsLink(metaResultsUrl, "imprint", imprintValue));
    }

    var imprintDividerEl = container.querySelector(".product-meta__imprint-divider");
    if (imprintDividerEl) {
      setVisible(imprintDividerEl, imprintValue !== "");
    }

    var publishDateEl = container.querySelector(".publishing_date");
    var publishDate = variantMeta.publication_date || "";
    setVisible(publishDateEl, publishDate !== "");

    if (publishDateEl && publishDate !== "") {
      var publishDateValueEl = publishDateEl.querySelector(".publishing_date_value");
      if (publishDateValueEl) {
        publishDateValueEl.textContent = publishDate;
      }
    }

    var weightEl = container.querySelector(".weight_block_wrapper");
    var weightValue = variantMeta.weight;
    var weightUnit = variantMeta.weight_unit || "";
    var hasWeight = weightValue !== null && weightValue !== undefined && String(weightValue) !== "" && String(weightValue) !== "0";
    setVisible(weightEl, hasWeight);

    if (weightEl && hasWeight) {
      var weightValueEl = weightEl.querySelector(".weight_block_value");
      if (weightValueEl) {
        weightValueEl.textContent = String(weightValue) + " " + weightUnit;
      }
    }

    var pageInfoEl = container.querySelector(".variant_metafield_page_info");
    var pageValue = variantMeta.page === null || variantMeta.page === undefined ? "" : String(variantMeta.page).trim();
    var hasPage = pageValue !== "";
    setVisible(pageInfoEl, hasPage);

    if (pageInfoEl && hasPage) {
      var pageInfoValueEl = pageInfoEl.querySelector(".variant_metafield_page_info_value");
      if (pageInfoValueEl) {
        pageInfoValueEl.textContent = pageValue;
      }
    }

    var formatInfoEl = container.querySelector(".variant_metafield_format_info");
    var formatValues = normalizeFormatValues(variantMeta.format);
    var hasFormat = formatValues.length > 0;
    setVisible(formatInfoEl, hasFormat);

    if (formatInfoEl && hasFormat) {
      formatInfoEl.innerHTML = "";

      formatValues.forEach(function (formatValue, index) {
        if (index > 0) {
          var andEl = document.createElement("span");
          andEl.textContent = "&";
          formatInfoEl.appendChild(andEl);
        }

        var valueEl = document.createElement("span");
        valueEl.className = "variant_metafield_format_info_value";
        valueEl.textContent = formatValue;
        formatInfoEl.appendChild(valueEl);
      });
    }

    var dimensionInfoEl = container.querySelector(".variant_dimension_info");
    var dimensionValue = variantMeta.dimension ? String(variantMeta.dimension).trim() : "";
    var hasDimension = dimensionValue !== "";
    setVisible(dimensionInfoEl, hasDimension);

    if (dimensionInfoEl && hasDimension) {
      var dimensionValueEl = dimensionInfoEl.querySelector(".variant_dimension_info_value");
      if (dimensionValueEl) {
        dimensionValueEl.textContent = dimensionValue;
      }

      var dimensionDividerEl = dimensionInfoEl.querySelector(".divider");
      if (dimensionDividerEl) {
        setVisible(dimensionDividerEl, hasPage || hasFormat);
      }
    }
  }

  function updateVariantPreorderState(container, variant, variantMeta) {
    if (!container || !variant || !variantMeta) {
      return;
    }

    var addButton = container.querySelector(".product-form__add-button");
    if (!addButton) {
      return;
    }

    var isAvailable = variant.available !== false;
    var isPreorder = !!variantMeta.is_preorder;
    var paymentContainer = container.querySelector(".product-form__payment-container");
    var preorderInput = container.querySelector("input.preorder_property");

    if (paymentContainer) {
      paymentContainer.classList.toggle("product-form__payment-container--preorder", isAvailable && isPreorder);
    }

    if (preorderInput) {
      preorderInput.name = "";
      preorderInput.value = "";
    }

    if (!isAvailable) {
      addButton.classList.remove("button--primary", "button--secondary");
      addButton.classList.add("button--disabled");
      addButton.setAttribute("disabled", "disabled");
      if (window.languages && window.languages.productFormSoldOut) {
        addButton.textContent = window.languages.productFormSoldOut;
      }
      return;
    }

    addButton.classList.remove("button--disabled");
    addButton.removeAttribute("disabled");

    if (isPreorder) {
      addButton.classList.remove("button--primary");
      addButton.classList.add("button--secondary");
      if (window.languages && window.languages.productFormPreOrder) {
        addButton.textContent = window.languages.productFormPreOrder;
      }
    } else {
      addButton.classList.remove("button--secondary");
      addButton.classList.add("button--primary");
      if (window.languages && window.languages.productFormAddToCart) {
        addButton.textContent = window.languages.productFormAddToCart;
      }
    }
  }

  function updateVariantMetaFromId(container, variantId, variantPayload) {
    var variantMetaMap = getVariantMetaMap(container);
    if (!variantMetaMap || !variantId) {
      return;
    }

    var variantMeta = variantMetaMap[String(variantId)];
    if (!variantMeta) {
      return;
    }

    var safeVariantPayload = variantPayload || {
      id: variantId,
      barcode: variantMeta.barcode || "",
      available: variantMeta.available !== false
    };

    container.querySelectorAll("[data-bbb-big-book-badge][data-context='product']").forEach(function (badge) {
      badge.hidden = variantMeta.is_big_size !== true;
      badge.dataset.variantId = String(variantId);
    });
    updateVariantBookDetails(container, safeVariantPayload, variantMeta);
    updateVariantPreorderState(container, safeVariantPayload, variantMeta);
  }

  function refreshVariantMetaForContainer(container) {
    if (!container || !container.querySelector) {
      return;
    }

    var variantIdInput = container.querySelector("input[name='id']");
    if (!variantIdInput || !variantIdInput.value) {
      return;
    }

    updateVariantMetaFromId(container, variantIdInput.value);
  }

  function refreshAllVariantMeta() {
    document.querySelectorAll("script[data-bbb-variant-meta]").forEach(function (script) {
      var container = script.closest(".card__section") || script.closest(".product-form") || script.parentElement;
      refreshVariantMetaForContainer(container);
    });
  }

  function findVariantMetaContainer(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest(".card__section") || target.closest(".product-form");
  }

  function init() {
    runMetaExpandContent();
    scheduleLockCleanup(true);
    refreshAllVariantMeta();
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) {
      return;
    }

    var showAllTrigger = target.closest(".show_all");
    if (showAllTrigger) {
      event.preventDefault();
      handleShowAllClick(showAllTrigger);
      return;
    }

    var copyTrigger = target.closest(".copyUrlLink");
    if (copyTrigger) {
      event.preventDefault();
      handleCopyLink(copyTrigger);
      return;
    }

    var badgeTrigger = target.closest(".primebDesktop[onclick*='redirectLinkbadge']");
    if (badgeTrigger) {
      var badgeUrl = getPrimeBadgeUrl(badgeTrigger);
      if (badgeUrl) {
        event.preventDefault();
        window.location.href = badgeUrl;
        return;
      }
    }

    if (
      target.closest(
        "[data-action='toggle-menu'], [data-action='open-panel'], [data-action='close-panel'], [data-action='toggle-mini-cart'], [data-action='open-drawer'], [data-action='close-drawer'], [data-action='open-modal'], [data-action='close-modal']"
      )
    ) {
      scheduleLockCleanup(false);
    }
  }, true);

  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape") {
      scheduleLockCleanup(false);
    }
  });

  document.addEventListener("theme:loading:end", function () {
    scheduleLockCleanup(true);
  });

  document.addEventListener("shopify:section:load", function () {
    runMetaExpandContent();
    scheduleLockCleanup(true);
    refreshAllVariantMeta();
  });

  document.addEventListener("variant:changed", function (event) {
    var variant = event.detail && event.detail.variant;
    var container = findVariantMetaContainer(event.target);
    if (!variant || !variant.id) {
      if (container) container.querySelectorAll("[data-bbb-big-book-badge][data-context='product']").forEach(function (badge) { badge.hidden = true; });
      return;
    }
    updateVariantMetaFromId(container, variant.id, variant);

    window.setTimeout(function () {
      refreshVariantMetaForContainer(container);
    }, 0);
  });

  document.addEventListener("change", function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(".color-swatch__radio[data-bbb-big-size]")) {
      var card = target.closest(".product-item");
      if (card) card.querySelectorAll("[data-bbb-big-book-badge][data-context='card']").forEach(function (badge) {
        badge.hidden = target.dataset.bbbBigSize !== "true";
        badge.dataset.variantId = new URL(target.dataset.variantUrl, window.location.origin).searchParams.get("variant") || "";
      });
    }
    if (
      !target ||
      !target.matches ||
      (!target.matches(".product-form__single-selector") && !target.matches("input[name='id']"))
    ) {
      return;
    }

    var container = findVariantMetaContainer(target);
    if (!container) {
      return;
    }

    window.setTimeout(function () {
      refreshVariantMetaForContainer(container);
    }, 50);
  });

  document.addEventListener("product:rerender", function (event) {
    var container = findVariantMetaContainer(event.target);

    window.setTimeout(function () {
      refreshVariantMetaForContainer(container);
    }, 0);
  }, true);

  var resizeMetaExpandTimer = null;
  window.addEventListener("resize", function () {
    if (resizeMetaExpandTimer) {
      window.clearTimeout(resizeMetaExpandTimer);
    }

    resizeMetaExpandTimer = window.setTimeout(function () {
      runMetaExpandContent();
      resizeMetaExpandTimer = null;
    }, 120);
  });
  window.addEventListener("pageshow", function () {
    scheduleLockCleanup(true);
  });
  window.addEventListener("popstate", function () {
    scheduleLockCleanup(true);
  });

  window.addEventListener("globoRelatedProductsAddedProductsToCart", function () {
    document.documentElement.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: { quantity: 0 }
      })
    );
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


(function () {
  function hasBlockingUIOpen() {
    return !!document.querySelector(
      "#mini-cart[aria-hidden='false'], " +
      "#mobile-menu[aria-hidden='false'], " +
      "#mobile-collection-filters[aria-hidden='false'], " +
      ".mobile-menu[aria-hidden='false'], " +
      ".search-bar.is-fixed, .search-bar.is-expanded, .search-bar__results[aria-hidden='false'], " +
      ".modal[aria-hidden='false'], dialog[open], " +
      ".drawer[aria-hidden='false'], .popover[aria-hidden='false'], " +
      ".value-picker[aria-hidden='false'], .value-picker[aria-expanded='true']"
    );
  }

  function unlockIfStale() {
    var root = document.documentElement;
    var body = document.body;
    if (!root || !body) return;

    var locked = root.classList.contains("is-locked") || body.classList.contains("is-locked");
    if (!locked || hasBlockingUIOpen()) return;

    root.classList.remove("is-locked");
    body.classList.remove("is-locked");
    root.style.overflow = "";
    root.style.overflowY = "";
    body.style.overflow = "";
    body.style.overflowY = "";
  }

  setInterval(unlockIfStale, 1000);
  window.addEventListener("pageshow", unlockIfStale);
  window.addEventListener("focus", unlockIfStale);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") unlockIfStale();
  });
})();

(function () {
  var BLOCK_SELECTOR = ".bbb-countdown-banner-app-block";
  var BUTTON_SELECTOR = ".product-form__payment-container > buy-button";
  var pending = false;

  function visibleButton(form) {
    var buttons = form.querySelectorAll(BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i += 1) {
      var rect = buttons[i].getBoundingClientRect();

      if (rect.width > 0 && rect.height > 0) {
        return buttons[i];
      }
    }

    return null;
  }

  function alignProductCountdownBlocks() {
    document.querySelectorAll("product-form").forEach(function (form) {
      var button = visibleButton(form);

      if (!button) {
        return;
      }

      var buttonRect = button.getBoundingClientRect();

      form.querySelectorAll(BLOCK_SELECTOR).forEach(function (block) {
        var parent = block.parentElement;

        if (!parent) {
          return;
        }

        var parentRect = parent.getBoundingClientRect();
        var width = Math.round(buttonRect.width);
        var left = Math.max(0, Math.round(buttonRect.left - parentRect.left));
        var banner = block.querySelector(".bbb-countdown-banner");

        block.style.width = width + "px";
        block.style.maxWidth = width + "px";
        block.style.marginLeft = left + "px";
        block.style.marginRight = "0";
        block.setAttribute("data-bbb-align", "add-to-cart");

        if (banner) {
          banner.style.width = "100%";
          banner.style.maxWidth = "100%";
        }
      });
    });
  }

  function scheduleAlign() {
    if (pending) {
      return;
    }

    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      alignProductCountdownBlocks();
    });
  }

  scheduleAlign();
  window.addEventListener("load", scheduleAlign);
  window.addEventListener("resize", scheduleAlign);
  document.addEventListener("shopify:section:load", scheduleAlign);

  new MutationObserver(scheduleAlign).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

(function () {
  "use strict";

  var BADGE_SELECTOR = "[data-bbb-variant-status-id]";
  var FALLBACK_BADGE_SELECTOR = ".block-swatch__item-status:not([data-bbb-variant-status-id])";
  var VARIANT_INPUT_SELECTOR = [
    "form[action*='/cart/add'] input[name='id']",
    "form[action*='/cart/add'] select[name='id']",
    "form[action='/cart/add'] input[name='id']",
    "form[action='/cart/add'] select[name='id']"
  ].join(", ");
  var APP_PROXY_FALLBACK = "/apps/bbb-eta-lab/status";
  var CACHE_TTL_MS = 30000;

  var cache = {};
  var timer = 0;
  var inflight = false;

  function getLabels() {
    var lang = String(
      (window.BBB_ETACartWriterConfig && window.BBB_ETACartWriterConfig.locale) ||
      document.documentElement.getAttribute("lang") ||
      navigator.language ||
      "en"
    ).toLowerCase();

    if (lang.indexOf("zh") === 0) {
      return {
        inStock: "\u6709\u5b58\u8ca8",
        onOrder: "\u53ef\u8a02\u8cfc",
        soldOut: "\u7f3a\u8ca8"
      };
    }

    return {
      inStock: "In stock",
      onOrder: "Orderable",
      soldOut: "Out of stock"
    };
  }

  function firstPresent() {
    for (var i = 0; i < arguments.length; i += 1) {
      if (arguments[i] !== undefined && arguments[i] !== null && arguments[i] !== "") {
        return arguments[i];
      }
    }

    return undefined;
  }

  function getProxyPath() {
    var rawPath = String(
      (window.BBB_ETACartWriterConfig && window.BBB_ETACartWriterConfig.appProxyPath) ||
      APP_PROXY_FALLBACK
    ).trim();
    var queryIndex = rawPath.indexOf("?");
    var pathname = queryIndex >= 0 ? rawPath.slice(0, queryIndex) : rawPath;
    var query = queryIndex >= 0 ? rawPath.slice(queryIndex) : "";

    if (/\/variants\/?$/i.test(pathname)) {
      pathname = pathname.replace(/\/variants\/?$/i, "/status");
    }

    return (pathname || APP_PROXY_FALLBACK) + query;
  }

  function normalizeRecord(row) {
    var status = String(row && firstPresent(row.status, row.inventoryStatus, row.inventory_status) || "")
      .trim()
      .toLowerCase();

    return {
      variantId: Number(row && firstPresent(row.variantId, row.variant_id, row.id)) || 0,
      status: status
    };
  }

  function buildStatus(rec) {
    var labels = getLabels();

    if (rec && rec.status === "in_stock") {
      return { name: "in-stock", badgeText: labels.inStock };
    }

    if (rec && rec.status === "on_order") {
      return { name: "on-order", badgeText: labels.onOrder };
    }

    return { name: "sold-out", badgeText: labels.soldOut };
  }

  function currentVariantId() {
    var input = document.querySelector(VARIANT_INPUT_SELECTOR);
    var value = input && (input.value || input.getAttribute("value"));
    var id = Number(value || 0);

    return Number.isFinite(id) ? id : 0;
  }

  function parseVariantIdFromScript(container) {
    var script = container && container.querySelector && container.querySelector("script[data-variant]");
    var parsed;

    if (!script) {
      return 0;
    }

    if (script.__bbbEtaVariantId !== undefined) {
      return script.__bbbEtaVariantId;
    }

    try {
      parsed = JSON.parse(script.textContent || "{}");
      script.__bbbEtaVariantId = Number(parsed && parsed.id) || 0;
    } catch (_) {
      script.__bbbEtaVariantId = 0;
    }

    return script.__bbbEtaVariantId;
  }

  function readVariantIdFromContainer(container) {
    var input = container && container.querySelector && container.querySelector("input[name='id'], select[name='id']");
    var attrValue =
      container &&
      container.getAttribute &&
      (container.getAttribute("data-variant-id") || container.getAttribute("data-product-variant-id"));
    var value = (input && (input.value || input.getAttribute("value"))) || attrValue;
    var id = Number(value || 0);

    if (Number.isFinite(id) && id > 0) {
      return id;
    }

    return parseVariantIdFromScript(container);
  }

  function pushTarget(targets, seenNodes, node, variantId, type) {
    if (!node || !(variantId > 0) || seenNodes.indexOf(node) >= 0) {
      return;
    }

    seenNodes.push(node);
    targets.push({ node: node, variantId: variantId, type: type });
  }

  function collectFallbackTargets(targets, seenNodes, selectedVariantId) {
    document.querySelectorAll("variant-picker").forEach(function (picker) {
      var variantId = readVariantIdFromContainer(picker) || selectedVariantId;
      var badges;

      if (!(variantId > 0)) {
        return;
      }

      badges = picker.querySelectorAll(FALLBACK_BADGE_SELECTOR);
      if (badges.length === 1) {
        pushTarget(targets, seenNodes, badges[0], variantId, "badge");
      }
    });
  }

  function collectTargets() {
    var targets = [];
    var seenNodes = [];
    var selectedVariantId = currentVariantId();

    document.querySelectorAll(BADGE_SELECTOR).forEach(function (node) {
      var variantId = Number(node.getAttribute("data-bbb-variant-status-id") || 0);
      pushTarget(targets, seenNodes, node, variantId, "badge");
    });

    collectFallbackTargets(targets, seenNodes, selectedVariantId);

    return targets;
  }

  function applyBadgeStatus(node, status) {
    var classNames = ["block-swatch__item-status--sold-out"];

    if (status.name === "in-stock") {
      classNames = ["block-swatch__item-status--in-stock"];
    } else if (status.name === "on-order") {
      classNames = ["block-swatch__item-status--on-order"];
    }

    node.classList.remove(
      "block-swatch__item-status--in-stock",
      "block-swatch__item-status--on-order",
      "block-swatch__item-status--restocking",
      "block-swatch__item-status--sold-out"
    );
    classNames.forEach(function (className) {
      node.classList.add(className);
    });

    if (String(node.textContent || "").trim() !== status.badgeText) {
      node.textContent = status.badgeText;
    }
  }

  function fetchRecords(variantIds) {
    var now = Date.now();
    var missing = [];
    var out = {};

    variantIds.forEach(function (id) {
      var cached = cache[id];

      if (cached && now - cached.time < CACHE_TTL_MS) {
        out[id] = cached.record;
      } else {
        missing.push(id);
      }
    });

    if (!missing.length) {
      return Promise.resolve(out);
    }

    var proxyPath = getProxyPath();
    var separator = proxyPath.indexOf("?") >= 0 ? "&" : "?";
    var shopDomain =
      (window.Shopify && window.Shopify.shop) ||
      (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.shopDomain) ||
      "";
    var url = proxyPath + separator + "ids=" + encodeURIComponent(missing.join(","));

    if (shopDomain) {
      url += "&shop=" + encodeURIComponent(shopDomain);
    }

    return fetch(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (payload) {
        var rows = payload && Array.isArray(payload.variants) ? payload.variants : [];

        rows.forEach(function (row) {
          var rec = normalizeRecord(row);
          if (rec.variantId > 0) {
            cache[rec.variantId] = { time: Date.now(), record: rec };
            out[rec.variantId] = rec;
          }
        });

        return out;
      })
      .catch(function () {
        return out;
      });
  }

  function run() {
    var targets = collectTargets();
    var variantIds = [];

    if (!targets.length) {
      return;
    }

    targets.forEach(function (target) {
      if (variantIds.indexOf(target.variantId) < 0) {
        variantIds.push(target.variantId);
      }
    });

    return fetchRecords(variantIds).then(function (records) {
      targets.forEach(function (target) {
        var rec = records[target.variantId];
        var status;

        if (!rec) {
          return;
        }

        status = buildStatus(rec);

        applyBadgeStatus(target.node, status);
      });
    });
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      if (inflight) {
        return;
      }

      inflight = true;
      Promise.resolve()
        .then(run)
        .finally(function () {
          inflight = false;
        });
    }, Math.max(0, Number(delay || 0)));
  }

  document.addEventListener("change", function (event) {
    if (event.target && event.target.closest && event.target.closest("form[action*='/cart/add']")) {
      schedule(80);
    }
  });

  ["variant:change", "variant:changed", "product:variant-change", "theme:variant:change"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      schedule(80);
    });
  });

  new MutationObserver(function () {
    schedule(180);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  schedule(0);
  window.setTimeout(function () { schedule(0); }, 300);
  window.setTimeout(function () { schedule(0); }, 900);
})();

(function () {
  var ON_ORDER_TEXT = String(
    document.documentElement.getAttribute("lang") || navigator.language || "en"
  ).toLowerCase().indexOf("zh") === 0 ? "\u53ef\u8a02\u8cfc" : "Orderable";
  var STORAGE_PREFIX = "bbb_eta_theme_dispatch_v1:";
  var STORE_TTL_MS = 10 * 60 * 1000;
  var timer = 0;

  if (!/\/products\//.test(window.location.pathname || "")) {
    return;
  }

  function normalizeText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function currentVariantId() {
    var urlVariant = Number(new URLSearchParams(window.location.search || "").get("variant") || 0);
    var formVariant = Number(
      document.querySelector("form[action*='/cart/add'] [name='id']") &&
      document.querySelector("form[action*='/cart/add'] [name='id']").value
    );
    return formVariant > 0 ? formVariant : urlVariant;
  }

  function readStoredDispatch(variantId) {
    if (!(variantId > 0)) {
      return "";
    }

    try {
      var raw = window.sessionStorage.getItem(STORAGE_PREFIX + variantId);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed || Date.now() - Number(parsed.t || 0) > STORE_TTL_MS) {
        window.sessionStorage.removeItem(STORAGE_PREFIX + variantId);
        return "";
      }
      return normalizeText(parsed.text);
    } catch (_) {
      return "";
    }
  }

  function writeStoredDispatch(variantId, text) {
    var clean = normalizeText(text);
    if (!(variantId > 0) || !clean) {
      return;
    }

    try {
      window.sessionStorage.setItem(
        STORAGE_PREFIX + variantId,
        JSON.stringify({ t: Date.now(), text: clean })
      );
    } catch (_) {}
  }

  function extractDispatchLine(text) {
    var clean = normalizeText(text);
    var match;

    if (!clean) {
      return "";
    }

    match = clean.match(/((?:Est\.?\s*dispatch|Re-stocking on|預計寄出|預計補貨)\s+\d{1,2}-[A-Za-z]{3}-\d{4}.*)$/i);
    return match && match[1] ? normalizeText(match[1]) : "";
  }

  function isOnOrderLike(text) {
    return /\borderable\b|\bon\s*order\b|\bpre[\s-]*order\b|可訂購|訂購中|預購/i.test(String(text || ""));
  }

  function findStockHost() {
    var root = document.querySelector(".product-form__info-item--stock .product-form__info-content");
    if (!root) {
      return null;
    }

    return (
      root.querySelector("[data-bbb-eta-stock='1']") ||
      root.querySelector(".product-form__inventory") ||
      root.querySelector(".inventory")
    );
  }

  function normalizeOnOrderBadges() {
    document.querySelectorAll(".block-swatch__item-status--on-order").forEach(function (node) {
      if (/\bpre[\s-]*order\b|預購/i.test(node.textContent || "")) {
        node.textContent = ON_ORDER_TEXT;
      }
      node.classList.remove("block-swatch__item-status--preorder");
    });
  }

  function normalizeOnOrderStockText(host) {
    var primary = host && host.querySelector && host.querySelector(".bbb-eta-stock-primary");
    var text = normalizeText(host && host.textContent);

    if (!host || !isOnOrderLike(text)) {
      return;
    }

    if (primary && /\bpre[\s-]*order\b|預購/i.test(primary.textContent || "")) {
      primary.textContent = ON_ORDER_TEXT;
      return;
    }

    if (
      /\bpre[\s-]*order\b|預購/i.test(text) &&
      !host.querySelector(".bbb-eta-stock-eta") &&
      host.children.length === 0
    ) {
      host.textContent = ON_ORDER_TEXT;
    }
  }

  function ensureDispatchLine(host, dispatchText) {
    var clean = normalizeText(dispatchText);
    var realEta;
    var heldEta;

    if (!host || !clean) {
      return;
    }

    realEta = Array.prototype.slice
      .call(host.querySelectorAll(".bbb-eta-stock-eta"))
      .filter(function (node) {
        return !node.classList.contains("bbb-eta-theme-held-dispatch");
      })[0];
    heldEta = host.querySelector(".bbb-eta-theme-held-dispatch");

    if (realEta && normalizeText(realEta.textContent)) {
      realEta.style.visibility = "";
      realEta.style.display = "";
      if (heldEta) {
        heldEta.remove();
      }
      return;
    }

    if (realEta) {
      realEta.textContent = clean;
      realEta.style.visibility = "";
      realEta.style.display = "";
      realEta.removeAttribute("aria-hidden");
      if (heldEta) {
        heldEta.remove();
      }
      return;
    }

    if (normalizeText(host.textContent).indexOf(clean) >= 0) {
      return;
    }

    if (!heldEta) {
      heldEta = document.createElement("div");
      heldEta.className = "bbb-eta-stock-eta bbb-eta-theme-held-dispatch";
      host.appendChild(heldEta);
    }

    heldEta.textContent = clean;
    heldEta.style.visibility = "";
    heldEta.style.display = "";
  }

  function run() {
    var host = findStockHost();
    var variantId = currentVariantId();
    var text = normalizeText(host && host.textContent);
    var dispatchText = extractDispatchLine(text);
    var storedText;
    var onOrderLike;

    normalizeOnOrderBadges();

    if (!host) {
      return;
    }

    normalizeOnOrderStockText(host);

    if (dispatchText) {
      writeStoredDispatch(variantId, dispatchText);
    }

    storedText = readStoredDispatch(variantId);
    onOrderLike =
      isOnOrderLike(text) ||
      host.getAttribute("data-bbb-eta-preorder") === "1" ||
      host.classList.contains("product-form__inventory--on-order") ||
      host.classList.contains("product-form__inventory--preorder");

    if (onOrderLike) {
      ensureDispatchLine(host, dispatchText || storedText);
    }
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, Math.max(0, Number(delay || 0)));
  }

  ["change", "variant:change", "variant:changed", "product:variant-change", "theme:variant:change"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      schedule(0);
      window.setTimeout(function () { schedule(0); }, 120);
      window.setTimeout(function () { schedule(0); }, 400);
    });
  });

  new MutationObserver(function () {
    schedule(80);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  schedule(0);
  window.setTimeout(function () { schedule(0); }, 300);
  window.setTimeout(function () { schedule(0); }, 900);
  window.setTimeout(function () { schedule(0); }, 1800);
})();

(function () {
  "use strict";

  var STYLE_ID = "bbb-product-audio-fallback-style";
  var GRAPHQL_VERSION = "2026-04";

  function productHandleFromPath() {
    var match = String(window.location.pathname || "").match(/(?:^|\/)products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : "";
  }

  function storefrontToken() {
    var node = document.getElementById("shopify-features");
    if (!node) return "";

    try {
      var payload = JSON.parse(node.textContent || "{}");
      return String(payload.accessToken || "");
    } catch (_) {
      return "";
    }
  }

  function normalizeAudioUrl(metafield) {
    var value = metafield && metafield.value;
    if (!value) return "";

    if (metafield.type === "json") {
      try {
        var parsed = JSON.parse(value);
        if (typeof parsed === "string") value = parsed;
        else if (parsed && typeof parsed.url === "string") value = parsed.url;
      } catch (_) {}
    }

    value = String(value || "").trim();
    return /^(https?:)?\/\//i.test(value) ? value : "";
  }

  function fetchAudioUrl(handle, token) {
    return fetch("/api/" + GRAPHQL_VERSION + "/graphql.json", {
      method: "POST",
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify({
        query: "query($handle:String!){ product(handle:$handle){ metafield(namespace:\"custom\", key:\"audio_url\"){ type value } } }",
        variables: { handle: handle }
      })
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        return normalizeAudioUrl(payload && payload.data && payload.data.product && payload.data.product.metafield);
      })
      .catch(function () { return ""; });
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      ".bbb-pdp-audio-overlay{display:none!important;pointer-events:none!important}",
      ".bbb-product-review-audio-row{display:flex;align-items:center;flex-wrap:wrap;gap:5px 9px;margin-top:2px;margin-bottom:2px}",
      ".bbb-product-review-audio-row [data-bbb-review][data-mode='badge'],.bbb-product-review-audio-row .product-meta__reviews-badge{display:inline-flex!important;align-items:center!important;width:auto!important;margin:0!important}",
      ".bbb-product-audio-host{display:inline-flex;align-items:center;vertical-align:middle;margin-top:2px}",
      ".product-meta>.bbb-product-audio-host{margin-top:6px}",
      ".bbb-product-audio.bbb-product-audio--inline{position:relative!important;top:auto!important;left:auto!important;z-index:1!important;--bbb-audio-progress:0%;width:auto!important;height:auto!important;max-width:100%!important;display:inline-flex!important;align-items:center!important;gap:5px!important;color:var(--text-color)!important;background:transparent!important;box-shadow:none!important;border-radius:0!important;overflow:visible!important;pointer-events:auto!important;vertical-align:middle!important;font-family:var(--text-font-family,inherit)!important;font-style:var(--text-font-style,inherit)!important;font-weight:var(--text-font-weight,inherit)!important;line-height:1.2!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1']{width:auto!important;height:auto!important;background:transparent!important;box-shadow:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__button{position:relative!important;width:18px!important;height:18px!important;min-width:18px!important;border:0!important;border-radius:999px!important;padding:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#fff!important;background:#333333!important;box-shadow:0 3px 9px rgba(51,51,51,.14)!important;-webkit-backdrop-filter:saturate(170%) blur(10px)!important;backdrop-filter:saturate(170%) blur(10px)!important;cursor:pointer!important;font-size:0!important;line-height:0!important;-webkit-appearance:none!important;appearance:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__button:hover,.bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__button:focus-visible{background:#3d3d3d!important;outline:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol{position:absolute!important;left:50%!important;top:50%!important;display:block!important;pointer-events:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--play{color:#ffbd00!important;width:0!important;height:0!important;border-top:4px solid transparent!important;border-bottom:4px solid transparent!important;border-left:7px solid currentColor!important;border-radius:1.5px!important;transform:translate(-38%,-50%)!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause{width:7px!important;height:8px!important;transform:translate(-50%,-50%)!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:before,.bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:after{content:\"\"!important;position:absolute!important;top:0!important;width:2.3px!important;height:8px!important;border-radius:999px!important;background:currentColor!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:before{left:0!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:after{right:0!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__label{display:inline-block!important;color:var(--text-color)!important;font-family:var(--text-font-family,inherit)!important;font-style:var(--text-font-style,inherit)!important;font-size:calc(var(--base-text-font-size) - (var(--default-text-font-size) - 14px))!important;font-weight:var(--text-font-weight,inherit)!important;line-height:1.2!important;white-space:nowrap!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1'] .bbb-product-audio__label{display:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__details{width:74px!important;min-width:74px!important;height:18px!important;display:none!important;align-items:center!important;padding:0 7px!important;border-radius:999px!important;background:#333333!important;box-shadow:0 3px 9px rgba(51,51,51,.14)!important;-webkit-backdrop-filter:saturate(170%) blur(10px)!important;backdrop-filter:saturate(170%) blur(10px)!important;opacity:1!important;transform:none!important;pointer-events:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1'] .bbb-product-audio__details{display:flex!important;pointer-events:auto!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__time{display:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__track{position:relative!important;flex:1 1 auto!important;width:100%!important;height:3px!important;border-radius:999px!important;background:rgba(255,255,255,.36)!important;cursor:pointer!important;overflow:hidden!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__track:before{content:\"\"!important;position:absolute!important;inset:0 auto 0 0!important;width:var(--bbb-audio-progress)!important;border-radius:inherit!important;background:#fff!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__track:focus-visible{outline:2px solid rgba(255,189,0,.45)!important;outline-offset:3px!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__audio{display:none!important}"
    ].join("");
    document.head.appendChild(style);
  }

  function firstVisible(elements) {
    return Array.prototype.slice.call(elements).find(function (element) {
      return element instanceof HTMLElement && !element.hidden && (element.offsetParent || element.getClientRects().length);
    });
  }

  function productScope(element) {
    return element && element.closest && element.closest("[data-section-type='product']") || document.querySelector("section[data-section-type='product']") || document;
  }

  function findReviewBadge(scope) {
    return firstVisible(scope.querySelectorAll("[data-bbb-review][data-mode='badge'], .product-meta__reviews-badge"));
  }

  function ensureReviewAudioRow(badge) {
    if (!badge || !badge.parentNode) return null;

    var row = badge.closest(".bbb-product-review-audio-row");
    if (row) return row;

    row = document.createElement("div");
    row.className = "bbb-product-review-audio-row";
    badge.parentNode.insertBefore(row, badge);
    row.appendChild(badge);
    return row;
  }

  function productAudioInlineHost() {
    var section = document.querySelector("section[data-section-type='product']") || document;
    var existing = section.querySelector("[data-bbb-product-audio-host]");
    if (existing) return existing;

    var host = document.createElement("span");
    host.className = "bbb-product-audio-host";
    host.setAttribute("data-bbb-product-audio-host", "");

    var badge = findReviewBadge(section);
    if (badge) {
      var row = ensureReviewAudioRow(badge);
      if (row) {
        row.appendChild(host);
        return host;
      }
    }

    var anchor = firstVisible(section.querySelectorAll(".product-meta__subtitle, .product-meta__title, .ProductMeta__Subtitle, .ProductMeta__Title, .product__subtitle, .product__title, .product-single__title, .product-info__title, h1"));
    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement("afterend", host);
      return host;
    }

    return null;
  }

  function placeAudioWithReview(root) {
    if (!root) return;
    var host = root.closest("[data-bbb-product-audio-host]");
    if (!host) return;

    var scope = productScope(host);
    var badge = findReviewBadge(scope);
    if (!badge || host.contains(badge)) return;

    var row = ensureReviewAudioRow(badge);
    if (row && host.parentNode !== row) {
      row.appendChild(host);
    }
  }

  function setIcon(button, isPlaying) {
    button.innerHTML = isPlaying
      ? '<span class="bbb-product-audio__symbol bbb-product-audio__symbol--pause" aria-hidden="true"></span>'
      : '<span class="bbb-product-audio__symbol bbb-product-audio__symbol--play" aria-hidden="true"></span>';
    button.setAttribute("aria-label", isPlaying ? "Pause audio" : "Play audio sample");
    button.setAttribute("title", isPlaying ? "Pause audio" : "Play audio sample");
  }

  function ensureRepairStyles() {
    if (document.getElementById("bbb-product-audio-v2-repair-style")) return;
    var style = document.createElement("style");
    style.id = "bbb-product-audio-v2-repair-style";
    style.textContent = [
      ".bbb-product-audio.bbb-product-audio--inline{position:relative!important;top:auto!important;left:auto!important;width:auto!important;height:auto!important;display:inline-flex!important;align-items:center!important;gap:5px!important;color:var(--text-color)!important;background:transparent!important;box-shadow:none!important;border-radius:0!important;overflow:visible!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1']{width:auto!important;height:auto!important;background:transparent!important;box-shadow:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__button{position:relative!important;color:#fff!important;background:#333333!important;box-shadow:0 3px 9px rgba(51,51,51,.14)!important;width:18px!important;height:18px!important;min-width:18px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:0!important;line-height:0!important}",
      ".bbb-product-audio__button svg[data-bbb-audio-icon]{display:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol{position:absolute!important;left:50%!important;top:50%!important;display:block!important;pointer-events:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--play{color:#ffbd00!important;width:0!important;height:0!important;border-top:4px solid transparent!important;border-bottom:4px solid transparent!important;border-left:7px solid currentColor!important;border-radius:1.5px!important;transform:translate(-38%,-50%)!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause{width:7px!important;height:8px!important;transform:translate(-50%,-50%)!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:before,.bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:after{content:\"\"!important;position:absolute!important;top:0!important;width:2.3px!important;height:8px!important;border-radius:999px!important;background:currentColor!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:before{left:0!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__symbol--pause:after{right:0!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__label{display:inline-block!important;color:var(--text-color)!important;font-size:calc(var(--base-text-font-size) - (var(--default-text-font-size) - 14px))!important;line-height:1.2!important;white-space:nowrap!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1'] .bbb-product-audio__label{display:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__details{width:74px!important;min-width:74px!important;height:18px!important;display:none!important;align-items:center!important;padding:0 7px!important;border-radius:999px!important;background:#333333!important;box-shadow:0 3px 9px rgba(51,51,51,.14)!important;opacity:1!important;transform:none!important;pointer-events:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline[data-open='1'] .bbb-product-audio__details{display:flex!important;pointer-events:auto!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__time{display:none!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__track{position:relative!important;flex:1 1 auto!important;width:100%!important;height:3px!important;border-radius:999px!important;background:rgba(255,255,255,.36)!important;cursor:pointer!important;overflow:hidden!important}",
      ".bbb-product-audio.bbb-product-audio--inline .bbb-product-audio__track:before{background:#fff!important}",
      ".bbb-pdp-audio-overlay{display:none!important;pointer-events:none!important}"
    ].join("");
    document.head.appendChild(style);
  }

  function repairAudioRoot(root) {
    if (!root) return;
    ensureRepairStyles();
    var button = root.querySelector("[data-bbb-product-audio-button]");
    var audio = root.querySelector("audio");
    if (!button) return;
    var isPlaying = !!(audio && !audio.paused && !audio.ended);
    var expectedSelector = isPlaying ? ".bbb-product-audio__symbol--pause" : ".bbb-product-audio__symbol--play";
    if (!button.querySelector(expectedSelector) || button.querySelector("[data-bbb-audio-icon]")) {
      setIcon(button, isPlaying);
    }
    placeAudioWithReview(root);
  }

  function repairAllAudioControls() {
    document.querySelectorAll("[data-bbb-product-audio]").forEach(function (root) {
      bindAudioRepair(root);
      repairAudioRoot(root);
    });
  }

  function scheduleAudioRepair(root) {
    repairAudioRoot(root);
    window.setTimeout(function () { repairAudioRoot(root); }, 0);
    window.setTimeout(function () { repairAudioRoot(root); }, 80);
  }

  function bindAudioRepair(root) {
    if (!root || root.getAttribute("data-bbb-product-audio-v2-repair") === "1") return;
    root.setAttribute("data-bbb-product-audio-v2-repair", "1");
    var audio = root.querySelector("audio");
    if (!audio) return;
    ["loadedmetadata", "play", "pause", "ended"].forEach(function (eventName) {
      audio.addEventListener(eventName, function () {
        scheduleAudioRepair(root);
      });
    });
  }

  function formatTime(value) {
    var seconds = Math.max(0, Math.floor(Number(value) || 0));
    return Math.floor(seconds / 60) + ":" + String(seconds % 60).padStart(2, "0");
  }

  function openAudio(root, button) {
    root.setAttribute("data-open", "1");
    button.setAttribute("aria-expanded", "true");
    var details = root.querySelector(".bbb-product-audio__details");
    if (details) details.setAttribute("aria-hidden", "false");
  }

  function collapseAudio(root) {
    if (!root) return;
    root.setAttribute("data-open", "0");
    var button = root.querySelector("[data-bbb-product-audio-button]");
    var details = root.querySelector(".bbb-product-audio__details");
    if (button) button.setAttribute("aria-expanded", "false");
    if (details) details.setAttribute("aria-hidden", "true");
  }

  function syncProgress(root, audio) {
    var current = root.querySelector("[data-bbb-product-audio-current]");
    var duration = root.querySelector("[data-bbb-product-audio-duration]");
    var track = root.querySelector("[data-bbb-product-audio-track]");
    var total = Number.isFinite(audio.duration) ? audio.duration : 0;
    var now = Number.isFinite(audio.currentTime) ? audio.currentTime : 0;
    var percent = total > 0 ? Math.max(0, Math.min(100, now / total * 100)) : 0;

    root.style.setProperty("--bbb-audio-progress", percent + "%");
    if (current) current.textContent = formatTime(now);
    if (duration) duration.textContent = total > 0 ? formatTime(total) : "--:--";
    if (track) track.setAttribute("aria-valuenow", String(Math.round(percent)));
  }

  function seekFromClientX(track, audio, clientX) {
    if (!track || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
    var rect = track.getBoundingClientRect();
    var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    audio.currentTime = ratio * audio.duration;
  }

  function handleDelegatedAudioClick(event) {
    var button = event.target && event.target.closest && event.target.closest("[data-bbb-product-audio-button]");
    var track = !button && event.target && event.target.closest && event.target.closest("[data-bbb-product-audio-track]");
    var control = button || track;
    if (!control) return;

    var root = control.closest("[data-bbb-product-audio]");
    if (!root) return;

    var audio = root.querySelector("audio");
    var activeButton = root.querySelector("[data-bbb-product-audio-button]");
    if (!audio || !activeButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openAudio(root, activeButton);

    if (track) {
      seekFromClientX(track, audio, event.clientX);
      return;
    }

    if (!audio.paused) {
      audio.pause();
      return;
    }

    audio.play().catch(function () {});
  }

  function injectAudio(url) {
    var host = productAudioInlineHost();
    if (!host || !url || host.querySelector("[data-bbb-product-audio]")) return false;

    ensureStyles();

    var root = document.createElement("span");
    root.className = "bbb-product-audio bbb-product-audio--inline";
    root.setAttribute("data-bbb-product-audio", "");
    root.setAttribute("data-open", "0");
    root.innerHTML = [
      '<button class="bbb-product-audio__button" type="button" aria-label="Play audio sample" aria-expanded="false" data-bbb-product-audio-button>',
      '<span class="bbb-product-audio__symbol bbb-product-audio__symbol--play" aria-hidden="true"></span>',
      '</button>',
      '<span class="bbb-product-audio__label">Audio sample</span>',
      '<span class="bbb-product-audio__details" aria-hidden="true">',
      '<span class="bbb-product-audio__time"><span data-bbb-product-audio-current>0:00</span><span>/</span><span data-bbb-product-audio-duration>--:--</span></span>',
      '<span class="bbb-product-audio__track" role="slider" aria-label="Audio progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" tabindex="0" data-bbb-product-audio-track></span>',
      '</span>',
      '<audio class="bbb-product-audio__audio" preload="metadata"></audio>'
    ].join("");

    var button = root.querySelector("button");
    var audio = root.querySelector("audio");
    var track = root.querySelector("[data-bbb-product-audio-track]");
    audio.src = url;

    ["click", "mousedown", "mouseup", "pointerdown", "touchstart"].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) { event.stopPropagation(); }, true);
    });

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openAudio(root, button);
      if (!audio.paused) {
        audio.pause();
        return;
      }
      audio.play().catch(function () {});
    });

    if (track) {
      track.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        openAudio(root, button);
        seekFromClientX(track, audio, event.clientX);
      });

      track.addEventListener("keydown", function (event) {
        var step = event.shiftKey ? 15 : 5;
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        openAudio(root, button);
        audio.currentTime = Math.max(0, Math.min(Number(audio.duration) || 0, audio.currentTime + (event.key === "ArrowRight" ? step : -step)));
      });
    }

    audio.addEventListener("loadedmetadata", function () { syncProgress(root, audio); });
    audio.addEventListener("durationchange", function () { syncProgress(root, audio); });
    audio.addEventListener("timeupdate", function () { syncProgress(root, audio); });
    audio.addEventListener("play", function () {
      root.setAttribute("data-playing", "1");
      openAudio(root, button);
      setIcon(button, true);
      syncProgress(root, audio);
    });
    audio.addEventListener("pause", function () {
      root.setAttribute("data-playing", "0");
      setIcon(button, false);
      syncProgress(root, audio);
    });
    audio.addEventListener("ended", function () {
      root.setAttribute("data-playing", "0");
      setIcon(button, false);
      syncProgress(root, audio);
    });

    syncProgress(root, audio);

    host.appendChild(root);
    placeAudioWithReview(root);
    return true;
  }

  function initProductAudioFallback() {
    if (document.querySelector("[data-bbb-product-audio]")) {
      document.querySelectorAll("[data-bbb-product-audio]").forEach(function (root) {
        bindAudioRepair(root);
        scheduleAudioRepair(root);
        placeAudioWithReview(root);
      });
      return;
    }

    var handle = productHandleFromPath();
    var token = storefrontToken();
    if (!handle || !token) return;

    fetchAudioUrl(handle, token).then(function (url) {
      if (!url) return;
      injectAudio(url);
      repairAllAudioControls();
      window.setTimeout(function () { injectAudio(url); }, 500);
      window.setTimeout(function () { injectAudio(url); }, 1500);
      window.setTimeout(repairAllAudioControls, 1600);
    });
  }

  if (!window.__BBB_PRODUCT_AUDIO_DELEGATE__) {
    window.__BBB_PRODUCT_AUDIO_DELEGATE__ = true;
    document.addEventListener("click", handleDelegatedAudioClick, true);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initProductAudioFallback)
    : initProductAudioFallback();
  repairAllAudioControls();
  window.setTimeout(repairAllAudioControls, 120);
  window.setTimeout(repairAllAudioControls, 800);

  document.addEventListener("product:rerender", initProductAudioFallback);
  document.addEventListener("shopify:section:load", initProductAudioFallback);
  document.addEventListener("click", function (event) {
    if (event.target && event.target.closest && event.target.closest("[data-bbb-product-audio]")) return;
    document.querySelectorAll("[data-bbb-product-audio]").forEach(collapseAudio);
  });
  document.addEventListener("keyup", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-bbb-product-audio]").forEach(collapseAudio);
  });
})();

